module.exports = __webpack_public_path__ + "static/media/animal_06_big.275340b3.png";